export default "__VITE_ASSET__B_NLbH45__"